
export default function ProblemSolution() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-16 text-gray-900">
          From Costly Rework to Guaranteed Precision
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* THE PROBLEM */}
          <div className="bg-white rounded-xl shadow-lg p-8 border-t-4 border-red-500 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-error-warning-fill text-red-600 text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-red-600">THE PROBLEM</h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              In high-rise construction, minor detailing and layout errors accumulate vertically,
              leading to multi-million dollar rework in the field, delayed schedules, and strained
              budgets. Relying on junior, in‑house staff increases this critical risk.
            </p>
          </div>

          {/* OUR CORE FOCUS */}
          <div className="bg-white rounded-xl shadow-lg p-8 border-t-4 border-blue-600 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-focus-3-fill text-blue-600 text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-blue-600">OUR CORE FOCUS</h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              We specialize exclusively in vertical construction detailing: core, slab, and curtain
              wall coordination. Our 20+ years of experience ensures geometry and embeds are
              accurate across all trades before mobilization.
            </p>
          </div>

          {/* THE DINARI GUARANTEE */}
          <div className="bg-white rounded-xl shadow-lg p-8 border-t-4 border-teal-600 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-shield-check-fill text-teal-600 text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-teal-600">THE DINARI GUARANTEE</h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              We deliver quality‑controlled detailing packages with flexible, 24/7 service. We
              eliminate your overhead, HR burden, and the risk of relying on a single,
              inexperienced employee.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
